// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class QuickTableCell {
    constructor() {
        // Cell data
        this.value = null;
        this.formattedValue = '';
        this.groupByValue = ''; // The context menu action "Group by" is processed using this value, e.g., #114165.
        // Colors
        this.BackColor = null;
        this.ForeColor = null;
        this.isDirty = true;
        this.textPattern = null;
        this.CustomDrawingHandler = null;
        this.CustomDrawingHandlerParameters = null;
        this.TooltipKey = '';
        this.isError = false;
    }
    CanShowTooltip() {
        return isNullOrUndefined(this.QuickTableEditingInfo)
            ? this.ReadOnly && isValidString(this.TooltipKey)
            : !this.ReadOnly || isValidString(this.TooltipKey);
    }
    GetTooltipKey() {
        if (isNullOrUndefined(this.QuickTableEditingInfo)) {
            return this.TooltipKey;
        }
        if (isValidString(this.TooltipKey)) {
            return this.TooltipKey;
        }
        return this.QuickTableEditingInfo.GetCellTooltipKey();
    }
}
